;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export interface EmployeeAdditionalData {
  [key: string]: string | number | undefined;
  joining_bonus_amount?: number;
  joining_bonus_date?: string;
  variable_bonus_amount?: number;
  social_card_number?: string;
  id_number?: string;
  personal_identification_number?: string;
  ahv_number?: string;
  national_identification_number?: string;
  passport?: string;
  birth_number?: string;
  valid_identification_card_or_passport?: string;
  ssn?: string;
  nif_nie?: string;
  amka?: string;
  tax_id_number?: string;
  passport_number?: string;
  oib_number?: string;
  identity_card_number?: string;
  pps_number?: string;
  identification_number?: string;
  italian_id_card_number?: string;
  fiscal_code?: string;
  passport_or_id_number?: string;
  personal_id_number?: string;
  identity_card_series?: string;
  jmb_number?: string;
  embg_number?: string;
  maltese_identity_card_number?: string;
  curp?: string;
  rfc?: string;
  citizen_service_number?: string;
  national_identity_number?: string;
  citizenship_certificate_number?: string;
  national_identity_document_number?: string;
  valid_identification_card?: string;
  pesel_number?: string;
  passport_or_citizen_card_number?: string;
  portuguese_taxpayer_number?: string;
  portuguese_ssn?: string;
  id_card_series?: string;
  cnp?: string;
  jmbg_number?: string;
  unit_code?: string;
  inn?: string;
  snils?: string;
  singapore_ic_number?: string;
  tax_number?: string;
  thai_identification_card_number?: string;
  national_identity_card_number?: string;
  turkish_identification_number?: string;
  document_type?: string;
  document_number?: string;
  identity_number?: string;
  annual_days?: string | number;
  probation_period_in_months?: string | number;
  probation_period_end_date?: string;
}

export interface EmployeeDetails {
  first_name: string;
  last_name: string;
  nationality_id: number | null;
  currency_id?: number;
  country_id: number;
  email: string;
  address: string;
  is_expat: boolean;
  user_id: number;
  status: string;
  additional_data?: EmployeeAdditionalData;
}
